module.exports = __webpack_public_path__ + "img/recharge_level_able.e6a991a8.png";